module.exports = require('./helpers/bundle-url').getBundleURL('2CT83') + "logo-dark.eefe0b7f.svg";